export default "__VITE_ASSET__BaHYK2$2__"